import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { UpdateUserForm } from '@/features/user/update-user-form'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/users/apk/list/update/$userId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas('../..')
  const { t } = useTranslation()

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Редактирование пользователя АПК')}>
      <UpdateUserForm onClose={close} />
    </Offcanvas>
  )
}
